import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export function AreaColorPicker({
  color,
  disabled,
  onChange,
}: {
  color: string;
  disabled: boolean;
  onChange: (color: string) => void;
}) {
  const { t } = useTranslation();
  const [hex, setHex] = useState(color);
  const chooseColor = (next: string) => {
    setHex(next);
    onChange(next);
  };

  return (
    <Popover
      onOpenChange={(open) => {
        if (open) setHex(color);
      }}
    >
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          disabled={disabled}
          className="size-14 shrink-0 flex-col gap-1.5 p-1 lg:px-1"
        >
          <span
            className="size-5 shrink-0 rounded-full border"
            style={{ backgroundColor: color }}
          />
          <span className="text-[0.5625rem] leading-none">{t('color')}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 space-y-4">
        <div className="grid grid-cols-4 gap-2">
          {[
            '#2563eb',
            '#16a34a',
            '#eab308',
            '#f97316',
            '#ef4444',
            '#a855f7',
            '#ec4899',
            '#64748b',
          ].map((value) => (
            <Button
              key={value}
              variant="ghost"
              className="size-10 p-2 lg:px-2"
              aria-label={t('useColor', { color: value })}
              aria-pressed={color === value}
              onClick={() => chooseColor(value)}
            >
              <span
                className="size-6 shrink-0 rounded-full border"
                style={{ backgroundColor: value }}
              />
            </Button>
          ))}
        </div>
        <Input
          label={t('customColor')}
          type="color"
          value={color}
          onChange={(event) => chooseColor(event.target.value)}
        />
        <Input
          label={t('hexColorInput')}
          value={hex}
          maxLength={7}
          placeholder="#2563eb"
          onChange={(event) => {
            const next = event.target.value;
            setHex(next);
            if (/^#[0-9a-fA-F]{6}$/.test(next)) onChange(next.toLowerCase());
          }}
          onBlur={() => setHex(color)}
        />
      </PopoverContent>
    </Popover>
  );
}
